import { Phone, Mail, CalendarDays, ArrowUpRight } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { QuoteTabs } from "./QuoteTabs";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, BOOK_URL } from "../lib/site";

const CONTACTS = [
  { I: Phone, label: "Call", value: PHONE_DISPLAY, href: `tel:${PHONE_TEL}`, id: "contact-call-link" },
  { I: Mail, label: "Email", value: EMAIL, href: `mailto:${EMAIL}`, id: "contact-email-link" },
  { I: CalendarDays, label: "Book a call", value: "Pick a time that suits you", href: BOOK_URL, id: "contact-book-link", ext: true },
];

export const QuoteSection = () => (
  <section id="quote" data-testid="quote-section" className="grain relative bg-[#0B281E] text-[#FAF8F5] py-24 lg:py-36 overflow-hidden">
    <div className="absolute bottom-[-30%] left-[-10%] w-[600px] h-[600px] rounded-full bg-[#C88A35]/15 blur-[140px] pointer-events-none" />
    <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5">
        <Reveal>
          <Eyebrow light>05 — Start here</Eyebrow>
          <h2 className="font-serif-d text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight mt-5 leading-[1.02]">Your free quote, <em className="text-[#E5A855]">personally</em> prepared.</h2>
          <p className="mt-6 text-[#F4F1EA]/80 leading-relaxed max-w-md">Choose Health, Life or Other, fill in a few details and I'll reach out within one business day. Prefer to talk now? Call, email or grab a time on my calendar.</p>
        </Reveal>
        <div className="mt-10 flex flex-col gap-3">
          {CONTACTS.map(({ I, label, value, href, id, ext }, i) => (
            <Reveal key={id} delay={0.1 + i * 0.08}>
              <a href={href} data-testid={id} {...(ext ? { target: "_blank", rel: "noreferrer" } : {})}
                className="group flex items-center gap-5 rounded-2xl border border-white/15 bg-white/[0.04] px-5 py-4 hover:bg-white/[0.09] hover:border-[#E5A855]/50 transition-colors">
                <span className="w-12 h-12 shrink-0 rounded-full bg-[#E5A855] text-[#071510] grid place-items-center"><I className="w-5 h-5" /></span>
                <span className="min-w-0 flex-1">
                  <span className="block font-mono-d text-[11px] uppercase tracking-[0.2em] text-[#E5A855]">{label}</span>
                  <span className="block truncate text-[#FAF8F5] mt-0.5">{value}</span>
                </span>
                <ArrowUpRight className="w-5 h-5 text-[#F4F1EA]/60 group-hover:rotate-45 group-hover:text-[#E5A855] transition-transform duration-500" />
              </a>
            </Reveal>
          ))}
        </div>
      </div>
      <Reveal className="lg:col-span-7" delay={0.1}>
        <QuoteTabs />
      </Reveal>
    </div>
  </section>
);
